<app-preloader *ngIf="loadingCompliance" [loaderText]="'Loading Compliance Report..'"
  class="w-100 position-fixed preloader-backdrop"></app-preloader>

<ng-container *ngIf="viewLocation !== 'publish'">
  <div class="w-100 d-flex jasper-report h-100 border-top-0">
    <!-- Left Panel -->
    <div class="col-2 px-0">
      <div class="nav flex-column" id="v-pills-tab" role="tablist" aria-orientation="vertical" aria-label="">
        <button class="btn btn-clear text-left p-3 w-100 border-bottom"
          [ngClass]="{'active':selectedMenu.title === tab.title}" id="v-pills-{{tab.title}}-tab" data-toggle="pill"
          role="tab" attr.aria-controls="v-pills-{{tab.title.split(' ').join('')}}" [attr.aria-selected]="selectedMenu.title===tab.title"
          (click)="onMenuSelected(tab)" *ngFor="let tab of menuList">
          <span class="w-100 font-bold d-block font-3x title">{{tab.title}}</span>
        </button>
      </div>
    </div>
    <!-- Left Panel Ends -->

    <!-- Right Panel -->
    <div class="col-10 pl-0 bg-lighter" *ngIf="selectedMenu">
      <div class="tab-content h-100" id="v-pills-tabContent">
        <div class="tab-pane fade show active col-12 h-100" id="v-pills-{{selectedMenu.title.split(' ').join('')}}" role="tabpanel"
          attr.aria-labelledby="v-pills-{{selectedMenu.title}}-tab">
          <ng-container *ngIf="selectedMenu.id===1">
            <ng-container *ngIf="!loadingCompliance">
              <!-- Complance report start -->
              <div [ngClass]="reportFound ? 'row align-items-stretch compliance-report h-100':''" tabindex="0">
                <ng-container *ngIf="reportFound">
                  <div [ngClass]="viewLocation === 'publish' ? 'd-flex w-100' : 'col-6 px-3 panel-left'">
                    <app-compliance-progress [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : ''"
                      [title]="caseCompliance" [progressDone]="caseComplianceData.filledNodes"
                      [progressTotal]="caseComplianceData.totalNodes"
                      [progressPercentage]="caseComplianceData.progressPercentage"></app-compliance-progress>
                    <div [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : 'mt-4'"
                      *ngIf="caseComplianceData.fields.length > 0">
                      <app-compliance-details [title]="'Top fields with CASE Compliance Issues'"
                        [description]="'The fields that caused the compliance issues'"
                        [itemList]="caseComplianceData?.fields" [itemType]="'issues'"></app-compliance-details>
                    </div>
                    <div [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : 'mt-4'"
                      *ngIf="caseComplianceData.nodes.length > 0">
                      <app-compliance-details [title]="'Top Nodes causing CASE Compliance'"
                        [description]="'Taxonomy nodes that are affected most'" [itemList]="caseComplianceData?.nodes"
                        [itemType]="'instances'"></app-compliance-details>
                    </div>
                  </div>

                  <div [ngClass]="viewLocation === 'publish' ? 'd-flex w-100 mt-5' : 'col-6 px-3 panel-right'">
                    <app-compliance-progress [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : ''"
                      [title]="coverage" [progressDone]="coverageComplianceData.filledNodes"
                      [progressTotal]="coverageComplianceData.totalNodes"
                      [progressPercentage]="coverageComplianceData.progressPercentage"></app-compliance-progress>
                    <div [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : 'mt-4'"
                      *ngIf="coverageComplianceData.fields.length > 0">
                      <app-compliance-details [title]="'Top fields with Coverage/Completion Issues'"
                        [description]="'The fields that caused the Coverage/Completion issues'"
                        [itemList]="coverageComplianceData?.fields" [itemType]="'issues'"></app-compliance-details>
                    </div>
                    <div [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : 'mt-4'"
                      *ngIf="coverageComplianceData.nodes.length > 0">
                      <app-compliance-details [title]="'Top Nodes causing Coverage/Completion'"
                        [description]="'Taxonomy nodes that are affected most'"
                        [itemList]="coverageComplianceData?.nodes" [itemType]="'instances'"></app-compliance-details>
                    </div>
                  </div>
                </ng-container>
                <p class="mb-0 pt-4" *ngIf="!reportFound" role="alert"><span class="sr-only">Error</span> No Compliance
                  Report Found </p>
              </div>
              <!-- Complance report end -->
            </ng-container>
          </ng-container>

          <ng-container *ngIf="selectedMenu.id===2">
            <div class="row align-items-stretch">
              <div class="col-12 pt-4 pb-2">
                <button class="btn btn-primary btn-sm" data-toggle="modal" data-target="#coverageReport"
                  (click)="onExportBtnClick()">Export<span class="sr-only">Opens in a new dialog</span></button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="selectedMenu.id === 3">
            <section class="row justify-content-center align-items-center">
              <div class="col-12 p-0">
                <h2 class="p-3 font-5x">Compare past versions to see what changed</h2>
              </div>

              <div class="dropdown col">
                <app-auto-complete [listingObj]="versionList" (selectedObject)="onVersionSelected($event, 'first')"
                  [selectType]="'single'" [uniqueId]="'opt_id'" [propName]="'display_publish_number'"
                  [isLableShow]="true" [isMandatory]="false" [autoCompleteTitle]="'First version'"
                  [showValidMsg]="false" [clrDisOnSelect]="false" [canDelete]="true" [index]='0'
                  [disabled]="showSpinner" [showSpinner]="showSpinner" #autoComplete_first>
                </app-auto-complete>
              </div>

              <div class="col-auto">
                <p class="mb-0 pt-4 font-3x font-bold">with</p>
              </div>

              <div class="dropdown col">
                <app-auto-complete [listingObj]="versionList" (selectedObject)="onVersionSelected($event, 'second')"
                  [selectType]="'single'" [uniqueId]="'opt_id'" [propName]="'display_publish_number'"
                  [isLableShow]="true" [isMandatory]="false" [autoCompleteTitle]="'Second version'"
                  [showValidMsg]="false" [clrDisOnSelect]="false" [canDelete]="true" [index]='1'
                  [disabled]="showSpinner" [showSpinner]="showSpinner" #autoComplete_second>
                </app-auto-complete>
              </div>

              <div class="col-12 my-3">
                <button class="btn btn-primary" (click)="loadComparisonRepot()" data-toggle="modal"
                  data-target="#versionModal">
                  Load Report
                </button>
              </div>

            </section>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Right Panel Ends -->
  </div>

  <!-- Export coverage report modal -->
  <ng-container *ngIf="taxonomyData && taxonomyData.children && taxonomyData.children[0]">
    <app-coverage-report-modal [sourceTaxonomytitle]="sourceTaxonomytitle"
      [sourceTaxonomyData]="taxonomyData.children[0]"></app-coverage-report-modal>
  </ng-container>
  <!-- Export coverage report modal end -->
</ng-container>
<ng-container *ngIf="viewLocation === 'publish'">
  <!-- Complance report start -->
  <div [ngClass]="reportFound ? 'row align-items-stretch compliance-report pt-3':''">
    <ng-container *ngIf="reportFound">
      <div [ngClass]="viewLocation === 'publish' ? 'd-flex w-100' : 'col-6 panel-left'">
        <app-compliance-progress [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : ''" [title]="caseCompliance"
          [progressDone]="caseComplianceData.filledNodes" [progressTotal]="caseComplianceData.totalNodes"
          [progressPercentage]="caseComplianceData.progressPercentage"></app-compliance-progress>
        <div [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : 'mt-4'" class="report-data"
          *ngIf="caseComplianceData.fields.length > 0">
          <app-compliance-details [title]="'Top fields with CASE Compliance Issues'"
            [description]="'The fields that caused the compliance issues'" [itemList]="caseComplianceData?.fields"
            [itemType]="'issues'"></app-compliance-details>
        </div>
        <div [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : 'mt-4'" class="report-data"
          *ngIf="caseComplianceData.nodes.length > 0">
          <app-compliance-details [title]="'Top Nodes causing CASE Compliance'"
            [description]="'Taxonomy nodes that are affected most'" [itemList]="caseComplianceData?.nodes"
            [itemType]="'instances'"></app-compliance-details>
        </div>
      </div>

      <div [ngClass]="viewLocation === 'publish' ? 'd-flex w-100 mt-5' : 'col-6 panel-right'">
        <app-compliance-progress [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : ''" [title]="coverage"
          [progressDone]="coverageComplianceData.filledNodes" [progressTotal]="coverageComplianceData.totalNodes"
          [progressPercentage]="coverageComplianceData.progressPercentage"></app-compliance-progress>
        <div [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : 'mt-4'" class="report-data"
          *ngIf="coverageComplianceData.fields.length > 0">
          <app-compliance-details [title]="'Top fields with Coverage/Completion Issues'"
            [description]="'The fields that caused the Coverage/Completion issues'"
            [itemList]="coverageComplianceData?.fields" [itemType]="'issues'"></app-compliance-details>
        </div>
        <div [ngClass]="viewLocation === 'publish' ? 'col-4 px-4' : 'mt-4'" class="report-data"
          *ngIf="coverageComplianceData.nodes.length > 0">
          <app-compliance-details [title]="'Top Nodes causing Coverage/Completion'"
            [description]="'Taxonomy nodes that are affected most'" [itemList]="coverageComplianceData?.nodes"
            [itemType]="'instances'"></app-compliance-details>
        </div>
      </div>
    </ng-container>
    <p class="mb-0" *ngIf="!reportFound" role="alert"><span class="sr-only">Error</span> No Compliance Report Found </p>
  </div>
  <!-- Complance report end -->

</ng-container>